import React, { useEffect, useState } from 'react';
import DraggableListComponent from './DraggableListComponent';
import LoadIcon from '../../../LoadIcon';

const MediaRowDraggable = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, componentType,
}) => {
  let initialState = {};
  if (componentType === 'PostDescriptionRow') {
    initialState = {
      type: componentType,
      name: '',
      arrow: true,
      slugnames: [],
      textColor: 'black',
    };
  } else {
    initialState = {
      type: componentType,
      slugnames: [],
    };
  }
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [posts, setPosts] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isColorWhite, setColorWhite] = useState(false);

  const handlerSetSlugNames = (slugnames) => {
    const newState = {
      ...state,
      slugnames,
    };
    setState(newState);
    const componentObj = {
      id,
      component: newState,
    };
    handlerSetComponents(componentObj, index);
    if (!slugnames.length) {
      setIsLoaded(true);
    }
  };


  useEffect(() => {
    if (index >= 0 && components.length) {
      const { component } = components[index];
      const fontColor = isColorWhite ? 'white' : 'black';

      const comp = {
        ...component,
        textColor: fontColor,
      };
      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  }, [isColorWhite]);


  const handleComponentBooleans = () => {
    const { component } = components[index];
    const comp = {
      ...component,
      textColor: isColorWhite ? 'white' : 'black',
    };
    setColorWhite(prevState => !prevState);

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    // Check if we are reading a component already done or if we are creating a new one
    if (component) {
      setState(component);
      if (component.hasOwnProperty('textColor')) setColorWhite(component.textColor === 'white' || false);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
    setIsLoaded(true);
  }, [components]);


  return (
    <div className="">
      {state.slugnames.length || isLoaded ? <DraggableListComponent components={state.slugnames} handlerSetComponentsInParent={handlerSetSlugNames} /> : <LoadIcon />}
      <div className="pb-0 mt-6px ml-1">
        <label htmlFor="textWhite" className="flex flex-col bg-greyFilter pl-10 font-americaMonoRegular text-xs uppercase text-black w-full mx-1 mt-1 w-full">
          Text Color
          <div className="pb-0 mt-6px ml-1 ">
            <label className="switch mb-0 pb-0 h-6">
              <input name="isTextWhite" className="switch" checked={isColorWhite} onChange={handleComponentBooleans} type="checkbox" />
              <div className="switch-slider btn-bw switch-round" />
            </label>
          </div>
        </label>
      </div>
    </div>
  );
};

export default MediaRowDraggable;
